module.exports = __webpack_public_path__ + "src/assets/img/m10.c5e5d1e2.svg";